import { render, staticRenderFns } from "./QuizDescription.vue?vue&type=template&id=53595f3d"
import script from "./QuizDescription.vue?vue&type=script&lang=js"
export * from "./QuizDescription.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports